import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';
export var SET_PREVIOUS_ROUTE = 'SET_PREVIOUS_ROUTE';